const $ = jQuery.noConflict();

'use strict';

const SalesLogin = {
	// DOM & classes
	$form: $('.js-sales-login-form'),
	inputEmailUser: '[name="email-username"]',
	inputPassword: '[name="password"]',
	classErrorGroup: 'has-error',
	classErrorMsg: 'form-error',
	classFormSubmitting: 'is-submitting',

	// Messages
	msgRequiredUser: 'Please enter your email or username.',
	msgInvalidEmail: 'Please enter a valid email address.',
	msgRequiredPass: 'Please enter your password.',

	init: function() {
		if (!this.$form.length) return;
		this.bindEvents();
	},

	bindEvents: function() {
		// Validate and submit on form submit
		this.$form.on('submit', (e) => {
			e.preventDefault();
			this.removeErrors();
			if (this.validateForm()) {
				this.setLoading(true);
				this.sendRequest();
			}
		});

		// Remove error on input or blur
		this.$form.on('input blur', this.inputEmailUser + ',' + this.inputPassword, (e) => {
			this.clearError($(e.currentTarget));
		});
	},

	validateForm: function() {
		let ok = true;

		const $user = this.$form.find(this.inputEmailUser);
		const $pass = this.$form.find(this.inputPassword);

		const userVal = $.trim($user.val());
		const passVal = $.trim($pass.val());

		if (!userVal) {
			this.setError($user, this.msgRequiredUser);
			ok = false;
		} else if (userVal.includes('@') && !this.isValidEmail(userVal)) {
			this.setError($user, this.msgInvalidEmail);
			ok = false;
		}

		if (!passVal) {
			this.setError($pass, this.msgRequiredPass);
			ok = false;
		}

		return ok;
	},

	isValidEmail: function(email) {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
		return re.test(String(email).toLowerCase());
	},

	setError: function($input, message) {
		const $group = $input.closest('.form-group');
		this.clearError($input);

		$group.addClass(this.classErrorGroup);
		$input.attr('aria-invalid', 'true');

		$group.append($('<span/>', {
			class: this.classErrorMsg,
			text: message,
			role: 'alert'
		}));
	},

	clearError: function($input) {
		const $group = $input.closest('.form-group');
		$group.removeClass(this.classErrorGroup);
		$input.removeAttr('aria-invalid');
		$group.find('.' + this.classErrorMsg).remove();
	},

	removeErrors: function() {
		this.$form.find('.' + this.classErrorMsg).remove();
		this.$form.find('.' + this.classErrorGroup).removeClass(this.classErrorGroup);
	},

	setLoading: function(state) {
		this.$form.toggleClass(this.classFormSubmitting, state);
	},

	sendRequest: function() {
		const data = {
			action: 'login-form',
			'email_or_username': $.trim(this.$form.find(this.inputEmailUser).val()),
			'password': $.trim(this.$form.find(this.inputPassword).val()),
		};

		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: data,
			success: (response) => {
				this.setLoading(false);
				this.handleResponse(response);
			},
			error: () => {
				this.setLoading(false);
				// Show a generic error always on email/username field
				this.setError(
					this.$form.find(this.inputEmailUser),
					'Something went wrong. Please try again.'
				);
			}
		});
	},

	handleResponse: function(response) {
		if (response.success) {
			this.$form[0].reset();
			if (response.data && response.data.redirect) {
				window.location.href = response.data.redirect;
			}
		} else {
			// If there are field-specific errors
			if (response.data && response.data.errors) {
				$.each(response.data.errors, (field, msgs) => {
					this.setError(
						this.$form.find(field === 'password' ? this.inputPassword : this.inputEmailUser),
						msgs[0]
					);
				});
			} else {
				// Generic server error -> always show on email field
				this.setError(
					this.$form.find(this.inputEmailUser),
					response.error || 'Login failed.'
				);
			}
		}
	},
};

export default SalesLogin;
